import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    DealerContract,
    DealerFeatureContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { Dealer } from '@polaris-customerweb/sharedcomponents.map';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { FeatureCollection, Point } from 'geojson';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DealerResource {
    private baseUrl: string;

    constructor(
        private configService: ConfigService,
        private http: HttpClient,
        routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'v1/dealers'
        );
    }

    getNearbyDealers(
        lat: number,
        lng: number,
        radius: number,
        limit: number
    ): Observable<Dealer[]> {
        const params = new HttpParams()
            .set('lat', String(lat))
            .set('lng', String(lng))
            .set('dst', String(radius))
            .set('max', String(limit))
            .set('skipAuthorization', 'true');
        const headers = new HttpHeaders().set(
            'Accept',
            'application/vnd.geo+json'
        );

        return this.http.get(this.baseUrl, { headers, params }).pipe(
            map((response: FeatureCollection<Point>) => {
                return response.features.map((dealer) =>
                    Dealer.create(
                        dealer as DealerFeatureContract,
                        this.configService.appSku
                    )
                );
            })
        );
    }

    getAllDealers(): Observable<Dealer[]> {
        let productLines = 'ATV,RGR,RZR,GEN,SNO';
        if (this.configService.isIndian) {
            productLines = 'IND';
        } else if (this.configService.isSlingshot) {
            productLines = 'SLG';
        }
        const params = new HttpParams()
            .set('productLines', productLines)
            .set('skipAuthorization', 'true');

        const headers = new HttpHeaders().set(
            'Accept',
            'application/vnd.geo+json'
        );

        return this.http.get(this.baseUrl, { headers, params }).pipe(
            map((response: FeatureCollection<Point>) => {
                return response.features.map((dealer) =>
                    Dealer.create(
                        dealer as DealerFeatureContract,
                        this.configService.appSku
                    )
                );
            })
        );
    }

    getDealerById(id: string): Observable<Dealer> {
        const params = new HttpParams().set('skipAuthorization', 'true');
        const headers = new HttpHeaders().set(
            'Accept',
            'application/vnd.geo+json'
        );
        const encodedId = encodeURIComponent(id);

        return this.http
            .get<DealerContract>(`${this.baseUrl}/find?id=${encodedId}`, {
                headers,
                params,
            })
            .pipe(
                map((dealer) =>
                    Dealer.create(dealer, this.configService.appSku)
                )
            );
    }
}
